export const LANDING_PLANS_PIE_DATA = [
	{ name: 'Professional', value: 29, color: '#72DE2F' },
	{ name: 'Premium', value: 36, color: '#F93030' },
	{ name: 'Basic', value: 29, color: '#5A6ACF' },
];

export const LANDING_PLANS_LINE_DATA = [
	{ day: '01', atual: 0, anterior: 15 },
	{ day: '02', atual: 20, anterior: 25 },
	{ day: '03', atual: 80, anterior: 60 },
	{ day: '04', atual: 60, anterior: 70 },
	{ day: '05', atual: 30, anterior: 45 },
	{ day: '06', atual: 70, anterior: 50 },
];

export const TESTIMONIALS_LINE_DATA = [
	{ day: '01', atual: 0, anterior: 5 },
	{ day: '02', atual: 10, anterior: 8 },
	{ day: '03', atual: 50, anterior: 35 },
	{ day: '04', atual: 20, anterior: 28 },
	{ day: '05', atual: 0, anterior: 12 },
	{ day: '06', atual: 40, anterior: 30 },
];
